import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Styles from "./FormDetailProgress.scss";

const FormDetailProgress = (props) => {
    let primaryColor = " #58D2C3";
    let backgroundColorTheme = " #454756";
    let baseColorTheme = " #FFFFFF";

    const [statesProgress, setStateProgress] = useState([

        {
            id: 1,
            title: "Instruction",
            name: "instruct",
            action: "instruct",
            active: false,
        },
        {
            id: 2,
            title: "Validation",
            name: "decid",
            action: "decid",
            active: false,
        },
    ]);

    useEffect(() => {}, []);

    useEffect(() => {
        let temp = [...statesProgress];
        temp.map((item, index) => {
            item.id < props.progress ? (temp[index].active = "passed") : false;
            item.id === props.progress
                ? (temp[index].active = "active")
                : false;
        });
        setStateProgress(temp);
    }, [props.progress]);

    return (
        <div
            className={
                "d-flex flex-column justify-content-center items-center eu-form-detail-progress"
            }
        >
            <div className={"h2 font-weight-bolder text-center my-2"}>
                Suivi dossier
            </div>
            <div
                className={
                    "d-flex flex-row my-2 p-4 w-100 text-center justify-content-between align-items-center"
                }
            >
                <div className={"ue-form-detail-progress-draw"} />
                {statesProgress.map((item) => {
                    return (
                        <div
                            key={item.id}
                            className={"d-flex ue-form-progress-state-item"}
                        >
                            {item.active === "passed" ? (
                                <div
                                    className={
                                        "ue-form-progress-state-round passed"
                                    }
                                ></div>
                            ) : (
                                <div
                                    className={
                                        item.active === "active"
                                            ? "ue-form-progress-state-round active"
                                            : "ue-form-progress-state-round"
                                    }
                                ></div>
                            )}
                            <div
                                className={
                                    item.active === "active"
                                        ? "ue-form-progress-state-title active"
                                        : "ue-form-progress-state-title"
                                }
                            >
                                {item.title}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        role: state.MeReducer.role,
        centerPageArg: state.DashboardReducer.centerPageArg,
        uiThem: state.AppReducer.uiThem,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        showCenterSection: (e) =>
            dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
        setCurrentCenterPage: (e) =>
            dispatch({ type: "SET_CURRENT_PAGE", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(FormDetailProgress);
